module.exports = function anonymous(it
) {
var out='<li class="log-entry notification error"> <div class="log-header centered"> <span rel="localize[log.error-loading]">'+(it.msg)+'</span> </div></li>';return out;
}